import { client } from "api/client";
import * as actions from "modules/common/store/actions";
import { CONFIGURATION } from "utilities/configuration";
import * as utility from "utilities/utils";
import { ENDPOINTS } from "utilities/endPoints";
import contentHelper from "utilities/contentHelper";
import mockQuote from "./mockQuote.json";

function getAll(params) {
    return async (dispatch) => {
        const url = `${process.env.REACT_APP_QUOTE_PROCESSOR}${ENDPOINTS.QUOTE_PROCESSOR.QUOTE_GET_ALL}`;
        const quote = utility.getResponse();
        quote.loading = false;
        quote.data = null;

        try {
            const response = await client.post(url, params);
            quote.loading = true;
            response?.data.quotes.map(quote => {
                quote.isExpanded = false;
            });

            quote.data = response?.data;

            return dispatch({
                type: actions.GET_QUOTES_SUCCESS,
                payload: quote
            });
        }
        catch (error) {
            return dispatch({
                type: actions.GET_QUOTES_FAIL,
                payload: utility.getErrorResponse(error)
            });
        }
    };
}

function getCustomQuote(quoteNumber) {
    return get(quoteNumber, true);
}

function get(quoteNumber, isDraftQuoteToCustomize = false) {
    return async (dispatch) => {

        try {
            const url = `${process.env.REACT_APP_QUOTE_PROCESSOR}${ENDPOINTS.QUOTE_PROCESSOR.QUOTE_GET}`;
            let response = await client.get(`${url}/${quoteNumber}${(isDraftQuoteToCustomize ? CONFIGURATION.ENDPOINT_GET_DRAFT_QUOTE_TO_CUSTOMIZE : "")}`);
            //let response = mockQuote;

            if(!isDraftQuoteToCustomize) {
                response = contentHelper.finalizeQuoteResponse(response, false);
            }
            
            let quote = {};
            quote = response?.data;

            quote?.quoteOptions?.map((quoteOption) => {
                quoteOption.products?.map((product) => {
                    product.itineraries?.map((itinerary) => {
                        itinerary.isExpanded = false;
                    });
                });
                if(quoteOption.deviationItinerary)
                    quoteOption.deviationItinerary.isExpanded = false;
            });

            const responseData = utility.getResponse(response);
            return dispatch({
                type: actions.GET_QUOTE_SUCCESS,
                payload: { ...responseData, data: responseData?.data?.data }
            });
        }
        catch (error) {
            return dispatch({
                type: actions.GET_QUOTE_FAIL,
                payload: utility.getErrorResponse(error)
            });
        }
    };
}


function getQuoteItinerary(params) {

    let { quoteNumber, itineraryID } = params;

    return async (dispatch) => {

        const url = `${process.env.REACT_APP_QUOTE_PROCESSOR}${ENDPOINTS.QUOTE_PROCESSOR.QUOTE_ITINERARY}`;

        try {
            const response = await client.get(`${url}/${quoteNumber}/${itineraryID}`);
            const responseData = utility.getResponse(response);
            return dispatch({
                type: actions.GET_QUOTE_ITINERARY_SUCCESS,
                payload: { ...responseData, data: responseData?.data?.data }
            });
        }
        catch (error) {
            return dispatch({
                type: actions.GET_QUOTE_ITINERARY_FAIL,
                payload: utility.getErrorResponse(error)
            });
        }
    };
}

export function getDeviationItinerary(params) {

    let { quoteNumber, itineraryID } = params;

    return async (dispatch) => {

        const url = `${process.env.REACT_APP_QUOTE_PROCESSOR}${ENDPOINTS.QUOTE_PROCESSOR.DEVIATION_ITINERARY}`;

        try {
            const response = await client.get(`${url}/${quoteNumber}/${itineraryID}`);
            const responseData = utility.getResponse(response);
            return dispatch({
                type: actions.GET_QUOTE_ITINERARY_SUCCESS,
                payload: { ...responseData, data: responseData?.data?.data }
            });
        }
        catch (error) {
            return dispatch({
                type: actions.GET_QUOTE_ITINERARY_FAIL,
                payload: utility.getErrorResponse(error)
            });
        }
    };
}
export function updateDeviationItinerary(params) {

    return async (dispatch) => {
        const url = `${process.env.REACT_APP_QUOTE_PROCESSOR}${ENDPOINTS.QUOTE_PROCESSOR.DEVIATION_ITINERARY}`;
        try {
            const response = await client.put(url, params);
            return dispatch({
                type: actions.GET_QUOTE_ITINERARY_SUCCESS,
                payload: utility.getResponse(response)
            });
        }
        catch (error) {
            return dispatch({
                type: actions.GET_QUOTE_ITINERARY_FAIL,
                payload: utility.getErrorResponse(error)
            });
        }
    };
}

function save(params, isIQMUser) {

    return async (dispatch) => {
        const url = `${process.env.REACT_APP_QUOTE_PROCESSOR}${ENDPOINTS.QUOTE_PROCESSOR.QUOTE_GET}`;
        let timedOut = false;

        const quote = utility.getResponse();
        quote.loading = false;
        quote.data = null;

        const timeoutId = setTimeout(() => {
            if (!isIQMUser) {
                timedOut = true;
                return dispatch({
                    type: actions.GET_QUOTE_TIMED_OUT,
                    payload: true
                }), 
                dispatch({
                    type: actions.SET_PROCESSING_STOP,
                    payload: false
                });
            }
        }, 2.5 * 60 * 1000);

        try {
            const response = await client.put(url, params, { method: "PUT" });

            // if not timeout yet, not matter what response returned, we should clear out the timer
            if (!timedOut && timeoutId)
            {
                clearTimeout(timeoutId);
            }

            quote.loading = true;
            quote.data = response?.data;

            if (response?.statusCode === 200) {
                if (!timedOut) {
                    return dispatch({
                        type: actions.SET_PROCESSING_STOP,
                        payload: false
                    }),
                    dispatch({
                        type: actions.GET_QUOTE_SUCCESS,
                        payload: quote
                    });
                };
            } 
            else {
                if (!timedOut && timeoutId) {
                    return dispatch({
                        type: actions.SET_PROCESSING_START,
                        payload: false
                    }),
                    dispatch({
                        type: actions.API_CALL_FAIL,
                        payload: utility.getErrorResponse(response?.ErrorInfo)
                    });
                }
            }
        }
        catch (error) {
            if (!timedOut && timeoutId) {
                // if not timeout yet, we should clear up the timer in catch
                clearTimeout(timeoutId);
                return dispatch({
                    type: actions.SET_PROCESSING_START,
                    payload: false
                }),
                dispatch({
                    type: actions.GET_QUOTE_FAIL,
                    payload: utility.getErrorResponse(error)
                });
            }
        }
    };
}

const quote = {
    get,
    getCustomQuote,
    getAll,
    save,
    getQuoteItinerary,
    getDeviationItinerary,
    updateDeviationItinerary
};

export default quote;
